import { render, staticRenderFns } from "./SdRichText.vue?vue&type=template&id=0aab229a&scoped=true"
import script from "./SdRichText.vue?vue&type=script&lang=js"
export * from "./SdRichText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab229a",
  null
  
)

export default component.exports